module.exports = __webpack_public_path__ + "static/media/c-american.c145caae.jpg";